import React from "react";
import { Link } from "react-router-dom";
import Wordmark from "../Brand/Wordmark";

/*
 * Velaigal public-pages footer.
 * Ink background, cream type, large Tamil glyph watermark in bottom-right.
 * Per spec §4.10. Use on every public/marketing page.
 */
const Footer: React.FC = () => {
  return (
    <footer className="relative overflow-hidden bg-ink text-hairline-strong pt-20 pb-10 px-8">
      <span
        aria-hidden="true"
        className="select-none pointer-events-none absolute -bottom-12 -right-4 leading-none"
        style={{
          fontFamily: '"Noto Serif Tamil", Georgia, serif',
          fontSize: "280px",
          color: "#2A2520",
          fontWeight: 500,
        }}
      >
        வே
      </span>

      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12">
          <div className="md:col-span-2">
            <div className="text-cream">
              <Wordmark variant="lockup" size="md" />
            </div>
            <p className="mt-5 text-sm text-hairline-strong max-w-xs leading-relaxed">
              Hiring built on real work — post a job, get real submissions, let AI pre-screen.
            </p>
            <p className="mt-6 text-[11px] uppercase tracking-widest text-hairline-strong/70">
              Made for hiring teams and jobseekers across the World.
            </p>
          </div>

          <div>
            <h3 className="text-[11px] font-medium uppercase tracking-widest text-hairline-strong mb-5">
              Product
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/features" className="text-sm text-hairline-strong hover:text-cream transition-colors no-underline">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/security" className="text-sm text-hairline-strong hover:text-cream transition-colors no-underline">
                  Security
                </Link>
              </li>
              <li>
                <Link to="/jobs" className="text-sm text-hairline-strong hover:text-cream transition-colors no-underline">
                  Browse jobs
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-[11px] font-medium uppercase tracking-widest text-hairline-strong mb-5">
              Company
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-hairline-strong hover:text-cream transition-colors no-underline">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-hairline-strong hover:text-cream transition-colors no-underline">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/status" className="text-sm text-hairline-strong hover:text-cream transition-colors no-underline">
                  Status
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-[11px] font-medium uppercase tracking-widest text-hairline-strong mb-5">
              Support
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/help-center" className="text-sm text-hairline-strong hover:text-cream transition-colors no-underline">
                  Help center
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-sm text-hairline-strong hover:text-cream transition-colors no-underline">
                  Sign in
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#3A3530] flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-hairline-strong">
          <span className="text-hairline-strong">
            © {new Date().getFullYear()} VELAIGAL.
          </span>
          {/*
           * Explicit text-hairline-strong on each link. Without it the global
           * `a { color: var(--color-ink); }` rule in index.css wins and the
           * links render ink-on-ink (effectively invisible on the dark footer).
           */}
          <div className="flex gap-6">
            <Link to="/terms" className="text-hairline-strong hover:text-cream transition-colors no-underline">
              Terms
            </Link>
            <Link to="/privacy" className="text-hairline-strong hover:text-cream transition-colors no-underline">
              Privacy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
